import JwtDecode from 'jwt-decode'

export default class Family {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new Family(obj)
    } catch (_) {
      return null
    }
  }

  constructor ({ family_id, email, first_connection, confirmed, is_admin, role }) {
    this.id = family_id
    this.email = email
    this.firstConnection = first_connection
    this.confirmed = confirmed
    this.is_admin = is_admin
    this.role = role

  }

  /**
   *
   * @returns {*|boolean}
   */
  get isAdministrator() {
    return this.is_admin && (this.role == 'admin' || this.role == 'dev')
  }

  /**
   *
   * @returns {*|boolean}
   */
  get isPayment() {
    return (this.is_admin && this.role == 'payment') || this.isAdministrator
  }

  /**
   *
   * @returns {*|boolean}
   */
  get isProf() {
    return (this.is_admin && this.role == 'prof')
  }

  /**
   *
   * @returns {*|boolean}
   */
  get isConsult() {
    return (this.is_admin && this.role == 'consult') || this.isPayment || this.isProf
  }

  /**
   * @returns {String}
   */
  get displayRole() {
    switch (this.role) {

      case 'admin': {
        return "Administrateur"
      }
      case 'dev': {
        return "Développeur"
      }
      case "payment": {
        return "Éditeur"
      }
      case "prof": {
        return "Professeur"
      }
      case "consult": {
        return "Lecteur"
      }
    }
  }




}
